import { render } from "./OnboardingSpotlight.vue?vue&type=template&id=fa157016&scoped=true"
import script from "./OnboardingSpotlight.vue?vue&type=script&lang=js"
export * from "./OnboardingSpotlight.vue?vue&type=script&lang=js"

import "./OnboardingSpotlight.vue?vue&type=style&index=0&id=fa157016&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa157016"]])

export default __exports__